import { render, staticRenderFns } from "./Juego.vue?vue&type=template&id=fc69710a&lang=pug&"
import script from "./Juego.vue?vue&type=script&lang=js&"
export * from "./Juego.vue?vue&type=script&lang=js&"
import style0 from "./Juego.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports